import type { CloneOptions } from "@/components/CloneView/components/CloneOptions/CloneOptionsSection";
import { bulkCopyItemActions } from "@/services/constant";
import type { AutomationAction, AutomationActions } from "@/types/automation";

const BATCHSIZE = 24;

export const prepareBatchItemActions = (
  selectedItems: string[],
  selectedTargetBoard: string | undefined,
  cloneOptions: CloneOptions,
  postfix: string
) => {
  const copyFromListAction = bulkCopyItemActions;
  const { parms } = copyFromListAction;
  const { input: actions } = parms;
  if (actions?.length) {
    const subAction = actions[0];
    subAction.toBoard = selectedTargetBoard;
    subAction.name = "@itemName@";
    updateCloneOptions(subAction, cloneOptions, postfix);
  }
  const bulkCloneBatches: AutomationActions[] = [];
  const itemsBatchList = new Array(Math.ceil(selectedItems.length / BATCHSIZE))
    .fill(null)
    .map(() => selectedItems.splice(0, BATCHSIZE));
  itemsBatchList.forEach((selectedItemsFromBatch) => {
    const _copyFromListAction: AutomationActions = JSON.parse(JSON.stringify(copyFromListAction)) as AutomationActions;
    _copyFromListAction.parms.list = selectedItemsFromBatch.join(",");
    bulkCloneBatches.push(_copyFromListAction);
  });
  return bulkCloneBatches;
};

const updateCloneOptions = (subAction: AutomationAction, cloneOptions: CloneOptions, postfix: string) => {
  Object.keys(cloneOptions).forEach((optionName) => {
    const checked = cloneOptions[optionName];
    if (checked) {
      if (optionName === "addPostfix") {
        subAction.name = "@itemName@ " + postfix;
      } else if (optionName === "copyUpdates") {
        subAction.copyUpdates = true;
      }
    }
  });
};
